import mentionedBrand1Src from '@/assets/images/kol/mentioned-brand-1.png'
import mentionedBrand2Src from '@/assets/images/kol/mentioned-brand-2.png'
import mentionedBrand3Src from '@/assets/images/kol/mentioned-brand-3.png'
import mentionedBrand4Src from '@/assets/images/kol/mentioned-brand-4.png'
import type { Brand } from '@/components/kol/common/mentioned-brand'
import getRandomNumber from '@/utils/get-random-number'

export const mockMentionedBrands: Brand[] = [
  {
    name: '雷達乳霜 Radar Face',
    platformName: '雷達乳霜 Radar Face',
    thumbnailUrl: mentionedBrand1Src,
    mentionCount: getRandomNumber(1, 10),
    etlAt: null,
  },
  {
    name: 'Radar Coffee',
    platformName: 'Radar Coffee',
    thumbnailUrl: mentionedBrand2Src,
    mentionCount: getRandomNumber(1, 10),
    etlAt: null,
  },
  {
    name: 'Radar Smile',
    platformName: 'Radar Smile',
    thumbnailUrl: mentionedBrand3Src,
    mentionCount: getRandomNumber(1, 10),
    etlAt: null,
  },
  {
    name: '雷達耳機 Radar Tech',
    platformName: '雷達耳機 Radar Tech',
    thumbnailUrl: mentionedBrand4Src,
    mentionCount: getRandomNumber(1, 10),
    etlAt: null,
  },
]
